<template>
  <v-row no-gutters justify="center" align="start">
    <div class="n-container">
      <router-view v-if="hasCompany"></router-view>
    </div>
  </v-row>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: `Settings`,
  computed: {
    ...mapState(`model/user`, [
      `me`,
    ]),
    ...mapState(`model/client`, [
      `company`,
    ]),
    ...mapState(`ui/settings`, [
      `rootTabs`,
      `aggregatorTabs`,
    ]),
    hasCompany() {
      return this.company && this.company.id;
    },
    tabs() {
      return this.company.isRoot ? this.rootTabs : this.aggregatorTabs;
    },
  },
  methods: {
    goToFirstTab() {
      if (this.$route.name === `settings`) {
        this.$router.replace(this.tabs[0].path);
      }
    },
  },
  beforeMount() {
    if (this.me.role !== `administrator`) {
      this.$router.replace(`/`);
    } else if (this.hasCompany) {
      this.goToFirstTab();
    }
  },
  watch: {
    hasCompany(hasCompany) {
      if (hasCompany) {
        this.goToFirstTab();
      }
    },
    '$route.path': function routePathChanged() {
      if (this.hasCompany) {
        this.goToFirstTab();
      }
    },
  },
};
</script>

<style lang="scss">

  @import "@/scss/variables.scss";

  .admin-list-actions {
    .v-icon {
      font-size: 20px !important;
    }
  }

  .left-admin-nav {
    ul {
      background-color: #FFF;
      list-style: none;
      padding-left: 0px !important;
      border: 1px solid #DDDDDD;
      border-radius: $contentCardRadius;

      li {
        padding: 10px 18px;
        &:first-child {
          border-top-left-radius: $contentCardRadius;
          border-top-right-radius: $contentCardRadius;
        }
        &:last-child {
          border-bottom-left-radius: $contentCardRadius;
          border-bottom-right-radius: $contentCardRadius;
        }
        &:not(:last-child) {
          border-bottom: 1px solid #DDDDDD;
        }
        &:hover {
          background-color: #EEEEEE;
          cursor: pointer;
          .v-icon {
            color: #777;
            display: block;
          }
        }
        &.active {
          background-color: $primaryColor;
          color: #FFF;
          font-weight: 500;
          .v-icon {
            color: #FFF;
            display: block;
          }
        }
        .v-icon {
          display: none;
        }
      }
    }
  }
</style>
